/**
 * What a phone does to the page, and what the game does back (qa-lead review,
 * 2026-10-26, problem 5). Presentation only: pausing stops the clock the way
 * the pause button does, and the sim never advances while paused.
 */

/** Where the app is, as far as leaving the page is concerned. */
export interface AwayState {
  readonly screen: 'menu' | 'game' | 'results' | 'garage';
  /** A shift is on screen and not over yet. */
  readonly playing: boolean;
  readonly paused: boolean;
  /** Held by a card or a lesson: the clock already waits, and the card is what comes back. */
  readonly held: boolean;
}

/**
 * Whether the page going out of sight pauses the shift. A phone locked mid-shift
 * used to come back with the clock running and no pause sheet.
 */
export function pausesWhenHidden(app: AwayState): boolean {
  return app.screen === 'game' && app.playing && !app.paused && !app.held;
}

export interface Size {
  readonly width: number;
  readonly height: number;
}

/**
 * Whether the home screen opens on the next shift again after a resize. A
 * phone turned sideways left Play under the street until the player scrolled.
 * A new width is a rotation or a new window; a small change in height alone is
 * a phone's address bar coming and going, and the player's own scroll stays.
 */
export function recentresAfter(before: Size, after: Size): boolean {
  // Hidden behind another screen: nothing to centre until it is back.
  if (after.width <= 0 || after.height <= 0) return false;
  if (before.width <= 0 || before.height <= 0) return true;
  if (Math.round(after.width) !== Math.round(before.width)) return true;
  return Math.abs(after.height - before.height) >= before.height * 0.25;
}
